/* ============================================================
   MONNAIE DU MONDE — disponibilite.js
   Disponibilité à date et heure fixes : bascule automatique « à venir » → « disponible »
   (ou « prévente » / « épuisé »), compte à rebours vivant, sans recharger la page.

   Prend en charge TOUT élément portant `data-disponible-le` (fiche produit : bouton + message,
   cartes produit des listes, agenda…). Contrat (miroir de snippets/disponibilite.liquid) :
     data-disponible-le   instant de mise à disposition : secondes UNIX (ex. 1792000800) ou date ISO
     data-etat            état courant (a_venir au départ) — réécrit par ce script
     data-apres           état une fois l'instant atteint : disponible | prevente | epuise (défaut disponible)
     data-msg-a_venir     modèle de libellé avant le seuil, ex. « Disponible le {date} »
     data-msg-compte      modèle du compte à rebours, ex. « Disponible dans {duree} »
     data-msg-<etat>      modèle pour chaque état d'arrivée (disponible, prevente, epuise, indisponible) ; vide = élément masqué
     data-seuil           heures avant lesquelles on passe en compte à rebours (défaut 48)
     data-secondes        « 1 » : afficher les secondes sous 5 minutes
     data-annonce         annoncer la bascule aux lecteurs d'écran (région [data-dispo-annonce])
     data-dispo-aria      recopier le libellé dans aria-label (modèles data-aria-<etat> / data-aria-compte sinon)
   Le libellé est écrit dans le premier [data-dispo-lib] de l'élément (sinon l'élément lui-même). Un <button>
   est désactivé tant que l'état n'est pas « disponible » ou « prevente ».
   Jetons : {date} 12 oct. à 9 h · {date_longue} jeudi 12 octobre 2026 à 9 h · {jour} · {heure} · {duree} 5 h 32 min.

   Fuseau : les dates affichées sont TOUJOURS celles de Paris (Intl, timeZone Europe/Paris), quel que soit
   le fuseau du visiteur ou celui de la boutique. L'instant, lui, est absolu.
   Précision : un seul minuteur recalé sur l'horloge à chaque passage (aucune dérive), re-vérification au retour
   d'onglet, correction de l'horloge du visiteur par l'en-tête `Date` du serveur.
   ============================================================ */
(function () {
  'use strict';
  if (window.mdmDisponibilite) { window.mdmDisponibilite.scan(document); return; }

  var FUSEAU = 'Europe/Paris';
  var NBSP = ' ';
  var MOIS_LONGS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var MOIS_COURTS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  /* libellés de secours si l'élément ne porte pas ses modèles */
  var DEFAUT = {
    a_venir: 'Disponible le {date}', compte: 'Disponible dans {duree}',
    disponible: 'Ajouter au panier', prevente: 'Précommander', epuise: 'Épuisé', indisponible: 'Indisponible',
    annonce: 'Cette pièce est maintenant disponible : vous pouvez l’ajouter au panier.',
    bientot: 'Disponible dans moins de 5 minutes.'
  };
  var CONNECTEUR = 'à';

  var decalage = 0;            /* horloge serveur − horloge visiteur (ms) */
  var suivis = [];
  var minuteur = null;
  var synchronise = false;
  var fNum = null;

  function maintenant() { return Date.now() + decalage; }

  /* ---------- date / heure de Paris ---------- */
  try {
    fNum = new Intl.DateTimeFormat('en-GB', { timeZone: FUSEAU, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' });
  } catch (e) { fNum = null; }

  function civil(t) {
    var d = new Date(t);
    if (!fNum) return { a: d.getFullYear(), m: d.getMonth() + 1, j: d.getDate(), h: d.getHours(), mn: d.getMinutes() };
    var o = {};
    fNum.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    return { a: +o.year, m: +o.month, j: +o.day, h: +o.hour % 24, mn: +o.minute };
  }
  function numJour(j) { return j === 1 ? '1er' : String(j); }
  function jourCourt(c, anneeCourante) {
    return numJour(c.j) + ' ' + MOIS_COURTS[c.m - 1] + (c.a !== anneeCourante ? ' ' + c.a : '');
  }
  function heure(c) {
    return c.h + NBSP + 'h' + (c.mn > 0 ? NBSP + (c.mn < 10 ? '0' : '') + c.mn : '');
  }
  function jourComplet(c, anneeCourante) {
    var sem = new Date(Date.UTC(c.a, c.m - 1, c.j)).getUTCDay();
    return JOURS[sem] + ' ' + numJour(c.j) + ' ' + MOIS_LONGS[c.m - 1] + (c.a !== anneeCourante ? ' ' + c.a : '');
  }
  /* durée jusqu'à l'instant : > 1 h → « 5 h 32 min » ; < 1 h → « 32 min » ; < 5 min (option) → « 4 min 12 s » */
  function duree(reste, avecSecondes) {
    if (reste < 0) reste = 0;
    if (avecSecondes && reste <= 300000) {
      var tot = Math.ceil(reste / 1000);
      var m = Math.floor(tot / 60), s = tot % 60;
      return m > 0 ? m + NBSP + 'min' + NBSP + (s < 10 ? '0' : '') + s + NBSP + 's' : s + NBSP + 's';
    }
    var minutes = Math.ceil(reste / 60000);
    var h = Math.floor(minutes / 60), mn = minutes % 60;
    if (h > 0) return h + NBSP + 'h' + (mn > 0 ? NBSP + (mn < 10 ? '0' : '') + mn + NBSP + 'min' : '');
    return mn + NBSP + 'min';
  }
  /* miroir de snippets/disponibilite-texte.liquid */
  function remplacer(modele, t, reste, avecSecondes) {
    var c = civil(t);
    var annee = civil(maintenant()).a;
    var texte = String(modele);
    if (texte.indexOf('{duree}') > -1) texte = texte.split('{duree}').join(duree(reste, avecSecondes));
    if (texte.indexOf('{date_longue}') > -1) texte = texte.split('{date_longue}').join(jourComplet(c, annee) + ' ' + CONNECTEUR + ' ' + heure(c));
    if (texte.indexOf('{date}') > -1) texte = texte.split('{date}').join(jourCourt(c, annee) + ' ' + CONNECTEUR + ' ' + heure(c));
    if (texte.indexOf('{jour}') > -1) texte = texte.split('{jour}').join(jourCourt(c, annee));
    if (texte.indexOf('{heure}') > -1) texte = texte.split('{heure}').join(heure(c));
    return texte;
  }

  /* ---------- lecture de l'instant : secondes UNIX, millisecondes ou ISO (+0200 / +02:00 / Z / espace) ---------- */
  function lireInstant(v) {
    if (v == null) return NaN;
    v = String(v).trim();
    if (!v) return NaN;
    if (/^\d+$/.test(v)) { var n = +v; return n < 1e11 ? n * 1000 : n; }
    v = v.replace(' ', 'T').replace(/\s+/g, '').replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
    var d = Date.parse(v);
    return isNaN(d) ? NaN : d;
  }

  /* ---------- région d'annonce (lecteurs d'écran) : seulement aux changements d'état, jamais à la seconde ---------- */
  function annoncer(rec, message) {
    var racine = rec.el.closest('[data-dispo-racine]') || document;
    var zone = racine.querySelector('[data-dispo-annonce]') || document.querySelector('[data-dispo-annonce]');
    if (!zone) return;
    zone.textContent = '';
    window.setTimeout(function () { zone.textContent = message; }, 60);
  }

  /* ---------- mise à jour d'un élément ---------- */
  function modele(el, cle) {
    var v = el.getAttribute('data-msg-' + cle);
    return v === null ? (DEFAUT[cle] || '') : v;
  }
  function ecrire(rec, texte) {
    var cible = rec.el.querySelector('[data-dispo-lib]') || rec.el;
    if (cible.textContent !== texte) cible.textContent = texte;
  }
  function appliquer(rec, etat, reste) {
    var el = rec.el;
    var venir = etat === 'a_venir';
    var cleModele = etat;
    var texte;
    if (venir) {
      cleModele = reste > rec.seuilMs ? 'a_venir' : 'compte';
      texte = remplacer(modele(el, cleModele), rec.t, reste, rec.secondes);
    } else {
      texte = modele(el, etat);
    }
    if (el.getAttribute('data-etat') !== etat) el.setAttribute('data-etat', etat);
    if (el.tagName === 'BUTTON') {
      var actif = etat === 'disponible' || etat === 'prevente';
      el.disabled = !actif;
      el.classList.toggle('carte__ajout--venir', venir);
    }
    ecrire(rec, texte);
    el.hidden = !texte;
    if (el.hasAttribute('data-dispo-aria')) {
      var a = el.getAttribute('data-aria-' + cleModele);
      el.setAttribute('aria-label', a ? remplacer(a, rec.t, reste, false) : texte);
    }
  }

  /* délai (ms) avant que le libellé change : changement de minute, de seconde (< 5 min), passage au compte à rebours, bascule */
  function prochain(rec, reste) {
    if (reste > rec.seuilMs) return Math.min(reste - rec.seuilMs + 5, 3600000);
    if (rec.secondes && reste <= 300000) return (reste % 1000 || 1000) + 5;
    var k = Math.ceil(reste / 60000);
    return Math.max(reste - (k - 1) * 60000, 1) + 5;
  }

  function tick() {
    window.clearTimeout(minuteur);
    var now = maintenant();
    var attente = Infinity;
    suivis = suivis.filter(function (rec) { return document.documentElement.contains(rec.el); });
    suivis.forEach(function (rec) {
      if (rec.fini) return;
      var reste = rec.t - now;
      if (reste <= 0) {
        rec.fini = true;
        appliquer(rec, rec.apres, 0);
        if (rec.annonce && rec.initialise) annoncer(rec, rec.el.getAttribute('data-txt-annonce') || DEFAUT.annonce);
        rec.el.dispatchEvent(new CustomEvent('mdm:disponible', { bubbles: true, detail: { etat: rec.apres, instant: rec.t } }));
        rec.initialise = true;
        return;
      }
      appliquer(rec, 'a_venir', reste);
      if (rec.annonce && rec.initialise && !rec.bientot && reste <= 300000) {
        rec.bientot = true;
        annoncer(rec, rec.el.getAttribute('data-txt-bientot') || DEFAUT.bientot);
      }
      if (reste <= 300000) rec.bientot = true;
      rec.initialise = true;
      attente = Math.min(attente, prochain(rec, reste));
    });
    if (attente !== Infinity) minuteur = window.setTimeout(tick, Math.max(attente, 25));
  }

  /* ---------- horloge du serveur (corrige un ordinateur à l'heure fausse) ---------- */
  function synchroniser() {
    if (synchronise || !window.fetch) return;
    synchronise = true;
    var url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    var t0 = Date.now();
    fetch(url, { cache: 'no-store', credentials: 'same-origin' }).then(function (r) {
      var t1 = Date.now();
      var d = Date.parse(r.headers.get('Date') || '');
      if (!isNaN(d)) {
        var mesure = (d + 500) - (t0 + t1) / 2;   /* l'en-tête Date est tronqué à la seconde */
        if (Math.abs(mesure) < 7 * 86400000) decalage = Math.abs(mesure) < 1200 ? 0 : mesure;
      }
      tick();
    }).catch(function () { /* hors ligne : on garde l'horloge du visiteur */ });
  }

  function scan(racine) {
    var nouveaux = 0;
    (racine || document).querySelectorAll('[data-disponible-le]').forEach(function (el) {
      if (el.__mdmDispo) return;
      var t = lireInstant(el.getAttribute('data-disponible-le'));
      if (isNaN(t)) return;
      el.__mdmDispo = true;
      nouveaux++;
      suivis.push({
        el: el, t: t,
        apres: el.getAttribute('data-apres') || 'disponible',
        seuilMs: (+el.getAttribute('data-seuil') || 48) * 3600000,
        secondes: el.getAttribute('data-secondes') === '1',
        annonce: el.hasAttribute('data-annonce'),
        initialise: false, fini: false, bientot: false
      });
    });
    if (nouveaux) {
      tick();
      if (suivis.some(function (r) { return !r.fini; })) synchroniser();
    }
  }

  window.mdmDisponibilite = {
    scan: scan, tick: tick, maintenant: maintenant,
    remplacer: remplacer, duree: duree, civil: civil, fuseau: FUSEAU
  };

  function reveiller() { if (suivis.length) tick(); }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) reveiller(); });
  window.addEventListener('pageshow', reveiller);
  window.addEventListener('focus', reveiller);
  window.addEventListener('online', function () { synchronise = false; if (suivis.length) synchroniser(); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
})();
